import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Registering Syncfusion license key and is only valid for version 31.x.x (This is not a secret)
registerLicense('Ix0oFS8QJAw9HSQvXkVhQlBad1hJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxWd0VhXn5dcHFWRWVbVEF9XEc=');

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
